import React from 'react';

import type {
  EventLevelCompoundMarketTemplateProps,
  MarketTemplateComponent
} from '@swf/sports/types/templates';

import TableColumnTable from '../../components/TableColumnTable/TableColumnTable';

export interface DisplayConfig {
  hideHeader?: boolean;
}

const EventTable: MarketTemplateComponent<
  EventLevelCompoundMarketTemplateProps & { displayConfig?: DisplayConfig }
> = ({ marketIds, config, displayConfig }) => (
  <TableColumnTable
    marketIds={marketIds}
    {...config}
    shouldHideHeader={displayConfig?.hideHeader}
    displayLevel={'EVENT'}
  />
);

EventTable.marketTemplateType = 'EVENT';

export default EventTable;
